import * as React from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend
} from "recharts";
import { filterAwardData, ColorLookup, percentageFormat, sumComparisonGroup, transformAwardData } from "./CTSAReportHelper";
import "./CommonChart.css";
import "./AwardChart.css";



const renderLegend = (compareGroup)=>(props) => {
    const { payload } = props;
    
    return (
        <div>
            {
                payload.map((entry, index) => (
                    <div key={`item-${index}`} className={`award-chart-legend ${(compareGroup.includes(entry.dataKey)&&payload.length>=2) && 'indent'}`} >
                        <span style={{ background: ColorLookup[entry.dataKey] }} className="award-chart-legend-colorblock"></span>
                        <span className="award-chart-legend-text">{entry.value}</span>
                    </div>
                ))
            }
        </div>
    );
}

interface Props {
    awardTotal?: {};
    awardData?: {}[];
    compareGroup?: string[];
}

class AwardChart extends React.Component<Props, {}> {
    render() {

        const { awardTotal, awardData, compareGroup } = this.props;
        const lineData = filterAwardData(transformAwardData(awardData), compareGroup, awardTotal);
        const { KL2, KCOMP } = lineData.filter(item => item.year === 5)[0];
        return <div className="chart-container">
            <h4 className="chart-title">R01 Attainment Following K Award Start Date</h4>
            <div className="svg-container">
                <LineChart width={800} height={450} data={lineData}>
                    <XAxis dataKey="year"
                        tickFormatter={tick => `${tick} years`}
                        label={{ value: "Years After Initial Award", position: "insideBottomRight", offset: -5, fontSize: 16 }}
                        tick={{ fontSize: 16 }}

                    />
                    <YAxis
                        label={{ value: "Cumulative R01 Attainment Percentage", position: "insideLeft", angle: -90, offset: 2, fontSize: 16 }}
                        tickFormatter={tick => `${tick}%`}
                        tick={{ fontSize: 16 }}
                    />
                    <CartesianGrid strokeDasharray="3 3" />
                    <Tooltip formatter={percentageFormat} />
                    <Legend iconSize={20} layout="vertical" align='right' verticalAlign="middle" wrapperStyle={{ right: '-20px' }} width={250} iconType="square" content={renderLegend(compareGroup)} />
                    {
                        compareGroup.length === 1 ?
                            ['KL2', ...compareGroup].map(award => <Line key={award} dataKey={award} stroke={ColorLookup[award]} type="monotone" activeDot={{ r: 5 }} name={`${award} (n=${awardTotal[award]})`} strokeWidth={award === 'KL2' ? 3 : 2}></Line>)
                            : ['KL2', 'KCOMP', ...compareGroup].map(award => <Line key={award} dataKey={award} stroke={ColorLookup[award]} type="monotone" activeDot={{ r: 5 }} name={award !== 'KCOMP' ? `${award} (n=${awardTotal[award]})` : `K Comparison Total (n=${sumComparisonGroup(awardTotal, compareGroup)})`} strokeWidth={(award === 'KL2' || award === 'KCOMP') ? 3 : 2} strokeDasharray={((award !== 'KL2') && (award !== 'KCOMP')) ? '3 3' : ''}></Line>)

                    }

                </LineChart>
            </div>
            <p style={{ paddingLeft: '25px', paddingTop: '25px'}}>The R01 award represents one marker of successful transition to research independence. This chart visually compares the rate of
R01 attainment by KL2 scholars and the selected comparison group(s) over time.</p>
            <ul>
                <li>{percentageFormat(KL2)} of KL2 scholars attained an R01 6 years after K award start date.</li>
                <li>{percentageFormat(KCOMP)} of K Comparison scholars attained an R01 6 years after K award start date.</li>
            </ul>
        </div>
    }
}



export default AwardChart;

